import { useMemo, useState } from 'react';
import { ApolloError } from '@apollo/client';

import {
  useGetMemberAttachmentUrlsQuery,
  useGetGroupActivitiesInProgressByKeyQuery,
  GetGroupActivitiesInProgressByKeyQuery
} from 'src/graphql/generated';
import { useErrorHandler } from 'src/hooks/useErrorHandler';

export const useMemberActivity = ({
  activityKey,
  memberId,
  skip
}: {
  memberId: string | undefined | null;
  activityKey?: string;
  skip: boolean;
}) => {
  const handleError = useErrorHandler();
  const [data, setData] = useState<GetGroupActivitiesInProgressByKeyQuery | undefined>();
  const [error, setError] = useState<ApolloError | undefined>();

  const { data: formData, loading } = useGetGroupActivitiesInProgressByKeyQuery({
    variables: { memberId: memberId, activityKey: activityKey },
    skip: !skip,
    onCompleted: setData,
    onError: (error) => {
      setError(error);
      if (!error?.message?.includes('Activity')) {
        handleError(error);
      }
    },
    fetchPolicy: 'cache-and-network'
  });

  const existingAttachments = data?.getGroupActivitiesInProgressByKey?.attachments?.map(
    (attachment) => {
      const { url, __typename, ...rest } = attachment!;
      return {
        ...rest
      };
    }
  );

  const { data: memberAttachmentsUrls } = useGetMemberAttachmentUrlsQuery({
    variables: { memberid: memberId, attachments: existingAttachments },
    skip: !data && !existingAttachments
  });

  const memberActivityData: GetGroupActivitiesInProgressByKeyQuery | undefined = useMemo(() => {
    return memberAttachmentsUrls && formData?.getGroupActivitiesInProgressByKey
      ? {
          getGroupActivitiesInProgressByKey: {
            ...formData.getGroupActivitiesInProgressByKey,
            attachments: memberAttachmentsUrls?.getMemberAttachmentsUrls
          }
        }
      : undefined;
  }, [data?.getGroupActivitiesInProgressByKey, memberAttachmentsUrls]);

  return { memberActivityData, error, loading };
};
